export enum LanguageEnum {
  'EN' = 'en',
  'ES' = 'es',
  'SO' = 'so',
}